import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isSeries } from 'helpers/ContentHelper';
import AirDate from 'componentsV2/Hero/components/AirDate';
import { getAirDate } from '../../helpers/ProcessorHelper';
import style from './Modal.module.scss';

const Modal = ({ item = {}, episode = {}, theme = {}, toggleModal, showModal, disableScroll }) => {
  const modalRef = useRef();
  const {
    seriesType,
    description = '',
    shortDescription = '',
    longDescription = '',
  } = episode.percentWatched ? episode : item;
  const data = isSeries(seriesType) ? episode : item;
  const { id, name = '' } = data;

  const modalCloseClickHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    toggleModal(false);
    disableScroll({ disableScroll: false, bodyOnly: false, fixedPosition: false });
  };

  const handleOverlayClick = e => {
    const { id: refId } = modalRef.current;
    const { id: targetId } = e.target;
    if (refId === targetId) modalCloseClickHandler(e);
  };
  const selectedLongDescription = longDescription || description || shortDescription;
  return showModal ? (
    <div
      className={classNames(style.modal, theme.modal)}
      ref={modalRef}
      id={id}
      onClick={handleOverlayClick}
    >
      <div className={classNames(style.inner, theme.inner)}>
        <div className={classNames(style.title, theme.title)}>{name}</div>
        <AirDate {...getAirDate(episode)} theme={style} />
        <div className={classNames(style.modalDescription, theme.modalDescription)}>
          {selectedLongDescription}
        </div>
        <div className={classNames(style.close, theme.close)} onClick={modalCloseClickHandler} />
      </div>
    </div>
  ) : null;
};

export default Modal;

Modal.propTypes = {
  disableScroll: PropTypes.func,
  episode: PropTypes.shape({}),
  item: PropTypes.shape({}),
  showModal: PropTypes.bool,
  theme: PropTypes.shape({}),
  toggleModal: PropTypes.func,
};
